'use client';
import React from 'react';

import { CommentText } from './Comment.styled';
import AddCommentForm from '@/ui/containers/CommentsSection/AddCommentForm';
import { parseSanitizedHTML } from '@/utils/helpers';

interface CommentContentProps {
  isEditing: boolean;
  content: string;
  id: number;
  setIsEditing: (isEditing: boolean) => void;
}

/**
 * @todo refactor
 * @param param0
 * @returns
 */
export default function CommentContent({ isEditing, setIsEditing, content, id }: CommentContentProps) {
  const htmlContent = React.useMemo(() => {
    return parseSanitizedHTML(content.replace(/<\/p>(\n|\r)<p>/g, '</p><p>').replace(/\n|\r/g, '<br />'));
  }, [content]);

  if (!isEditing) {
    return <CommentText>{htmlContent}</CommentText>;
  }

  return <AddCommentForm editCommentId={id} initialContent={content} onSuccessCallback={() => setIsEditing(false)} />;
}
